<template>
  <div class="partner-resumes-base">
    <div class="partner-resumes-base__head">
      <h1 class="partner-resumes-base__title">{{ $tResumesBase('Resumes base') }}</h1>
      <button @click.prevent="showInvitePopup = true" class="partner-resumes-base__head-btn  base-btn  base-btn--green">
        <BaseSvg name="ico-plus"
                 width="1.1rem"
                 height="1.1rem"/>
        <span>{{ $tResumesBase('Invite a candidate') }}</span>
      </button>
      <router-link-modified v-if="isPartner || isAgent"
                            tag="button"
                            class="partner-resumes-base__head-btn base-btn  base-btn--green"
                            :to="{ name: 'account-register-candidate' }">
        <BaseSvg name="ico-plus"
                 width="1.1rem"
                 height="1.1rem"/>
        <span>{{ $tResumesBase('Register a candidate') }}</span>
      </router-link-modified>
    </div>

    <SubpagesTabs :routes="tabsRoutes"
                  class="partner-resumes-base__tabs  _grey">
      <transition name="fade"
                  mode="out-in">
        <router-view @invite-employee="showInvitePopup = true"
                     @registration-employee="showRegistrationPopup = true"
        ></router-view>
      </transition>
    </SubpagesTabs>

    <transition name="fade">
      <APInvitePopup v-if="showInvitePopup"
                     @close="showInvitePopup = false"/>
    </transition>
  </div>
</template>

<script>
  import {PARTNER, AGENT} from '@/constants/usersTypes'
  import SubpagesTabs from '@/components/SubpagesTabs'
  import APInvitePopup from '@/components/partnerResumeBaseResumes/APInvitePopup'

  export default {
    name: 'AccountPartnerResumesBasePage',
    components: {
      APInvitePopup,
      SubpagesTabs
    },
    data() {
      return {
        showInvitePopup: false,
        showRegistrationPopup: false
      }
    },
    computed: {
      isPartner() {
        return this.$store.getters['user/userType'] === PARTNER
      },
      isAgent() {
        return this.$store.getters['user/userType'] === AGENT
      },
      tabsRoutes() {
        if (this.isPartner) {
          return [{
            id: 1,
            name: this.$tResumesBase('Resumes base'),
            route: {name: 'account-partner-resumes-base-resumes'}
          }, {
            id: 2,
            name: this.$tResumesBase('On interaction'),
            route: {name: 'account-partner-resumes-base-on-interaction'}
          }]
        } else if (this.isAgent) {
          return [{
            id: 1,
            name: this.$tResumesBase('Resumes base'),
            route: {name: 'account-agent-resumes-base-resumes'}
          }, {
            id: 2,
            name: this.$tResumesBase('On interaction'),
            route: {name: 'account-agent-resumes-base-on-interaction'}
          }]
        }

        return []
      }
    }
  }
</script>

<style lang="less">

</style>
